export default __webpack_public_path__ + "static/media/Construction-rafiki.039a6f40.svg";